module.exports = __webpack_public_path__ + "img/instalacion.b5a3be94.jpg";